import React, { useState } from "react";
import "./FaqSection.css";
import dots from "../../assets/dots.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const faqItems = [
  {
    number: "01",
    title: "What makes AgentGRC.ai different from traditional GRC platforms?",
    content:
      "Traditional GRC tools track and report — AgentGRC.ai orchestrates. It provides real-time oversight, policy enforcement, and compliance automation purpose-built for AI systems.",
  },
  {
    number: "02",
    title: "How does AgentGRC.ai support AI governance across the lifecycle?",
    content:
      "AgentGRC.ai embeds governance from model development to deployment. It monitors behavior, flags risks, enforces policies, and ensures alignment with global regulations.",
  },
  {
    number: "03",
    title: "Can AgentGRC.ai help with regulatory compliance?",
    content:
      "Yes. It maps requirements from standards like the EU AI Act, NIST RMF, and ISO 42001 directly to operational workflows and generates audit-ready documentation.",
  },
  {
    number: "04",
    title:
      "Does AgentGRC.ai support oversight of third-party or embedded AI systems?",
    content:
      "Absolutely. It extends governance to vendor models, APIs, and embedded AI — ensuring control beyond internal systems.",
  },
  {
    number: "05",
    title: "How does AgentGRC.ai handle explainability?",
    content:
      "It integrates with tools like LIME, SHAP, and Truera to generate human-readable insights, supporting internal review and external audits.",
  },
  {
    number: "06",
    title: "Who can use AgentGRC.ai within the organization?",
    content:
      "It's built for cross-functional teams — enabling collaboration among compliance, legal, IT, data science, and risk management.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  return (
    <section
      className={`second-faq-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="five"
    >
      {/* second-accordion-container */}
      <div className="container ">
        <div className="section-tag">
          <img src={dots} alt="dots" />
          <p>FAQ</p>
        </div>
        <div className="second-faq-section-heading">
          <h2>AgentGRC: Your Guide to Common Inquiries</h2>
          <p>
            Have questions about AgentGRC? You’re in the right place. Discover
            how intelligent automation strengthens your governance, risk, and
            compliance workflows—from policy management to audits—with seamless,
            AI-powered support
          </p>
        </div>
        <div className="second-accordion">
          {faqItems.map((item, index) => (
            <div className="second-accordion-item" key={index}>
              <button
                id={`second-accordion-button-${index}`}
                aria-expanded={openIndex === index}
                onClick={() => toggleAccordion(index)}
              >
                <span className="second-accordion-title">{item.title}</span>
                <span className="icon" aria-hidden="true">
                  {openIndex === index ? "" : ""}
                </span>
              </button>
              {openIndex === index && (
                <div className="second-accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
